import * as yup from 'yup'

const schema = yup.object().shape({
  justify: yup.string().required(),
})

export default schema
